import './CustomUpload.scss';
import { useState } from "react";
import { ReactComponent as Camera } from '../../assets/Camera.svg'
import "react-image-crop/dist/ReactCrop.css";
import ReactCrop, { makeAspectCrop, centerCrop } from "react-image-crop";
import PrimaryButton from '../../../../components/prime-react-overrides/button/Button';
import Modal from '../../../../components/prime-react-overrides/modal/Modal';
import { toast } from 'react-hot-toast';
import { useEffect } from 'react';

const acceptedFileTypes = ['image/png', 'image/jpg', 'image/jpeg']

function CustomUpload({ imageLink, imageType, updateImageLink,showEditTextHide }) {

	const [modalImgSrc, setModalImgSrc] = useState(null)
	const [crop, setCrop] = useState(null);
	const [showModal, setShowModal] = useState(false)
	const [isImageCropped, setIsImageCropped] = useState(false)
	const [startCrop, setStartCrop] = useState(false)
	useEffect(() => {

		if (imageLink !== null) {
			setModalImgSrc(imageLink)
			// setImgSrc(imageLink)
			// setImgType(imageType)
			setIsImageCropped(imageLink)
		}
	}, [imageLink])

	useEffect(() => {
		updateImageLink(modalImgSrc, acceptedFileTypes[0])
	}, [modalImgSrc])


	// handle image
	function onSelectFile(e, error) {
		if (e.target.files[0].size > 5242880 || !acceptedFileTypes.includes(e.target.files[0].type)) {
			toast.error(error?.message ?? `Please select proper format image less than 5MB`)
		}
		else if (e.target.files && e.target.files.length === 1) {

			const reader = new FileReader()
			reader.addEventListener('load', () => {
				setShowModal(true)
				setModalImgSrc(reader.result)
			})
			reader.readAsDataURL(e.target.files[0])
		}
		else {
			toast.error(error?.message ?? `Please add only one image`)
		}
	}

	const handleSubmit = async (e) => {
		e.preventDefault();
		setStartCrop(false)
		makeClientCrop()
	}

	const makeClientCrop = async (error) => {
		if (crop.width && crop.height) {
			createCropPreview();
			setStartCrop(false)
		}
		else {
			toast.error(error?.message ?? `Please Crop the image`)
		}
	};

	// make this as a utility function
	const createCropPreview = async () => {

		const canvas = document.createElement('canvas');
		const imageInstance = document.getElementById('modalImage')

		const scaleX = imageInstance.naturalWidth / imageInstance.width;
		const scaleY = imageInstance.naturalHeight / imageInstance.height;
		const ctx = canvas.getContext("2d");
		canvas.height = crop.height
		canvas.width = crop.width


		ctx.drawImage(imageInstance, crop.x * scaleX, crop.y * scaleY, crop.width * scaleX, crop.height * scaleY, 0, 0, crop.width, crop.height)
		setModalImgSrc(canvas.toDataURL())
		setIsImageCropped(true)
		setShowModal(false)
		setStartCrop(false)
	};

	const handleEdit = () => {
		setIsImageCropped(false)
		setModalImgSrc(false)
		setShowModal(false)
		setStartCrop(false)
		setTimeout(handleInputFileClick, 50)
	}
	const handleInputFileClick = () => {
		document.getElementById('AddPicture').click()
	}

	const addImage = (
		<div className='Upload cursor-pointer flex flex-column justify-content-center align-items-center py-4 px-5' onClick={handleInputFileClick}>
			<Camera className="CameraSvg mb-2" />
			<div className=''>
				<input
					type="file"
					accept={`${acceptedFileTypes.join(',')}`}
					id='AddPicture'
					name='AddPicture'
					onChange={(e) => onSelectFile(e)}
					style={{ display: 'none' }}
				/>
				<label className='cursor-pointer text-xs font-semibold'>Add Picture</label>
			</div>
		</div>
	)
	const imagePreview = (
		<div className='ImageContainer flex flex-column align-items-center'  >
			<img src={modalImgSrc} height="100px" width="100px" alt='Cropped image' />
			{
			!showEditTextHide &&
				<div className='Edit  cursor-pointer flex align-items-center justify-content-center '>
					<p className='m-0 text-center font-medium text-lg' onClick={() => handleEdit()} >Edit</p>
				</div>
			}
		</div>
	)

	const handleCrop = (pixelCrop, percentCrop) => {
		setStartCrop(true)
		setCrop(pixelCrop)
	}
	const handleImageLoad = (e) => {
		const { naturalWidth: width, naturalHeight: height } = e.currentTarget;

		const crop = centerCrop(
			makeAspectCrop(
				{
					unit: '%',
					width: 50,
				},
				1,
				width,
				height
			),
			width,
			height
		)

		setCrop(crop)
	}

	const handleModalClose = () => {
		setModalImgSrc(null)
		setIsImageCropped(false)
		setShowModal(false)
		setStartCrop(false)
	}


	return (
		<>
			<Modal appendTo="" header='Upload Picture' visible={showModal} onHide={handleModalClose} draggable={false} breakpoints={{ '640px': '100vw' }} style={{ maxWidth: '50vw' }} >
				<div className='flex h-full  w-full justify-content-center'>
					<ReactCrop crop={crop} onChange={handleCrop} aspect={1} keepSelection minHeight={100} minWidth={100} >
						<img alt="Loading..." id='modalImage' src={modalImgSrc} onLoad={handleImageLoad} className="w-full h-auto" />
					</ReactCrop>
				</div>
				<div className='flex flex-row justify-content-center my-4' >
					<PrimaryButton className='py-2 px-5 mx-2' variant='flat' onClick={(e) => { handleSubmit(e) }} disabled={!startCrop}   >Submit</PrimaryButton>
				</div>
			</Modal>
			<div className='CustomUpload' >
				{isImageCropped ? imagePreview : addImage}
			</div>
		</>
	);
}

CustomUpload.defaultProps = {
	showEditTextHide: false
}

export default CustomUpload